export const shop = {
  branches: [],
  annotations: [
    {
      key: 'orderer',
      label: '申請人資訊',
      value: '{{customer.DELIVERY_NAME}}',
      required: true,
      type: 'ORDERER',
      validation: null,
      prerequisities: null,
      placeholder: '',
      isSystem: true,
    },
    {
      key: 'payment',
      label: '付款方式',
      value: '{{customer.PAYMENT_KEY}}',
      required: true,
      type: 'OPTIONS',
      validation: null,
      prerequisities: null,
      placeholder: '',
      sources: [
        { key: 'FACE', label: '面交付款' },
        { key: 'CUSTOM', label: '後續報價' },
      ],
      isSystem: true,
    },
    {
      key: 'delivery',
      label: '配送方式',
      value: '{{customer.DELIVERY_KEY}}',
      required: true,
      type: 'OPTIONS',
      validation: null,
      prerequisities: null,
      placeholder: '',
      sources: [{ key: 'FACE', label: '面交' }],
      isSystem: true,
    },
    {
      key: 'coupon',
      label: '折扣碼',
      value: '{{customer.META.coupon}}',
      required: false,
      type: 'COUPON',
      validation: null,
      prerequisities: null,
      placeholder: '',
      isSystem: true,
    },
    {
      key: 'INPUT_d2c890f0-b9af-41f1-a6b6-6ec836813486',
      label: '備註',
      value: '{{customer.META.INPUT_d2c890f0-b9af-41f1-a6b6-6ec836813486}}',
      required: false,
      type: 'INPUT',
      validation: null,
      prerequisities: null,
      placeholder: '',
    },
  ],
  settings: {
    formica: {
      categoryInfos: [
        {
          id: 1319,
          title: '富美家®裝飾\\n美耐板^潔菌板:木紋',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-24feed82-d109-4fbc-bb90-6be7ee375eda',
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-1fbe59e9-8da9-4abb-a43c-7b80ddc76b92',
          ],
        },
        {
          id: 1318,
          title: '富美家®裝飾\\n美耐板^潔菌板:富美家®彩虹心®',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-1fbe59e9-8da9-4abb-a43c-7b80ddc76b92',
          ],
        },
        {
          id: 1315,
          title: '富美家®彩之芯:彩之戀',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-046f1149-c177-4e77-89a2-4347219131a1',
          ],
        },
        {
          id: 1310,
          title: '富美家®彩之芯:彩繪',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-d8b59359-2268-4c17-a1c7-4eff6043ddae',
          ],
        },
        {
          id: 1309,
          title: '富美家®裝飾\\n美耐板^潔菌板:彩繪',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-d8b59359-2268-4c17-a1c7-4eff6043ddae',
          ],
        },
        {
          id: 1303,
          title: '富美家®裝飾\\n美耐板^潔菌板:彩之戀',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-0377e01c-02e4-4bc5-a80e-6f53f8fe0a41',
          ],
        },
      ],
    },
  },
};

export const liff = {
  error: '',
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getProfile: async () => {
    // dev
    return {
      userId: 'U1bb8c428b1c8945bbf5f7a82374d0735',
      displayName: '黃卷 Juan',
      statusMessage: 'じゅえん',
      pictureUrl:
        'https://profile.line-scdn.net/0hDLs-FdmaG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRVRnYFg2ezNUhg',
    };
  },
  getAccessToken: () =>
    'eyJhbGciOiJIUzI1NiJ9.mnL3wWV819mdqBFs6L5AMma1FKOk7Ud7a31u4bF370Vm-_wvFhYdIeTFQUAf959sYUBnlLy4kiW-saVcQCEEZdp6cQo48QxFAlwtdBJa1KZsB629T-LMQ_eW0FSNNtHFtypGj--ZFxGTjFyF9IDyBr8cpRihEs149bUjQwzK7IQ.3ruKuj2p_Fjwqx-8Hqm5KbFQSZeOmGlU6FRbPmhvrlE',
  isLoggedIn: () => true,
  isInClient: () => false,
};
